import React from 'react';
export function Hook() {
  return <section className="w-full bg-white" data-id="element-70" data-mp="3vc9d4p5tbcx">
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-20" data-id="element-71" data-mp="2b623yjaf0mkr">
        <p className="font-display text-2xl font-bold leading-snug tracking-tight text-navy-950 sm:text-[2rem]" data-id="element-72" data-mp="2b48tsu0lfk80">
          ¿Alguna vez has sentido la frustración de perder contra alguien que corre menos que tú,
          golpea más flojo, pero parece estar siempre en el lugar correcto?
        </p>
        <div className="mt-6 space-y-4 border-l-2 border-lime-400 pl-6 text-lg leading-relaxed text-navy-800/80" data-id="element-73" data-mp="2ozte9tvz0ahj">
          <p data-id="element-74" data-mp="2tynyn09l673r">
            En el pickleball, la fuerza no sirve de nada si no dominás la{' '}
            <strong className="font-semibold text-navy-950" data-id="element-75" data-mp="2g3lrk9t06bpd">zona de no-volea</strong>.
          </p>
          <p data-id="element-76" data-mp="2k4njs6oi5nhu">
            La mayoría de los jugadores cometen el error de jugar como si fuera tenis, y por eso
            siempre terminan perdiendo los puntos largos.
          </p>
        </div>
      </div>
    </section>;
}